import Vue from 'vue'
import VueRouter from 'vue-router'
// import treaty from '../views/treaty.vue'
import treaty from '../views/userLabel/treaty.vue'

Vue.use(VueRouter)

// 解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

//replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};


const routes = [
  // {
  //   path: '/',
  //   name: 'treaty',
  //   component: treaty
  // },
  // {
  //   path: '/resolve',
  //   name: 'resolve',
  //   component: () => import(/* webpackChunkName: "resolve" */ '../views/resolve.vue')
  // },
  // {
  //   path: '/result',
  //   name: 'result',
  //   component: () => import(/* webpackChunkName: "resolve" */ '../views/result.vue')
  // },
  // 用户风险标签认证解限
  {
    path: '/',
    name: 'treaty',
    component: treaty
  },
  {
    path: '/resolve',
    name: 'resolve',
    component: () => import(/* webpackChunkName: "resolve" */ '../views/userLabel/resolve.vue')
  },
  {
    path: '/resolveTwo',
    name: 'resolveTwo',
    component: () => import(/* webpackChunkName: "resolve" */ '../views/userLabel/resolveTwo.vue')
  },
  {
    path: '/phoneVerify',
    name: 'phoneVerify',
    component: () => import(/* webpackChunkName: "resolve" */ '../views/userLabel/phoneVerify.vue')
  },
  {
    path: '/result',
    name: 'result',
    component: () => import(/* webpackChunkName: "resolve" */ '../views/userLabel/result.vue')
  },
  {
    path: '/kba/action',
    name: 'kbaAction',
    component: () => import('../views/userLabel/kba/index.vue')
  },
  {
    path: '/kba/chat',
    name: 'kbaChat',
    component: () => import('../views/userLabel/kba/chat.vue')
  },
  {
    path: '/kba/result',
    name: 'kbaResult',
    component: () => import('../views/userLabel/kba/result.vue')
  },
  // 反养蜂认证解限
  {
    path: '/antibee/treaty',
    name: 'antibeeTreaty',
    component: () => import(/* webpackChunkName: "resolve" */ '../views/antibee/treaty.vue')
  },
  {
    path: '/antibee/resolve',
    name: 'antibeeResolve',
    component: () => import(/* webpackChunkName: "resolve" */ '../views/antibee/resolve.vue')
  },
  {
    path: '/antibee/resolveTwo',
    name: 'antibeeResolveTwo',
    component: () => import(/* webpackChunkName: "resolve" */ '../views/antibee/resolveTwo.vue')
  },
  {
    path: '/antibee/result',
    name: 'antibeeResult',
    component: () => import(/* webpackChunkName: "resolve" */ '../views/antibee/result.vue')
  },
  // 风险标签 + 人脸核身
  {
    path: '/validate/treaty',
    name: 'validateTreaty',
    component: () => import(/* webpackChunkName: "resolve" */ '../views/h5OcrValidate/treaty.vue')
  },
  {
    path: '/validate/resolve',
    name: 'validateResolve',
    component: () => import(/* webpackChunkName: "resolve" */ '../views/h5OcrValidate/resolve.vue')
  },
  {
    path: '/validate/resolveTwo',
    name: 'validateResolveTwo',
    component: () => import(/* webpackChunkName: "resolve" */ '../views/h5OcrValidate/resolveTwo.vue')
  },
  {
    path: '/validate/result',
    name: 'validateResult',
    component: () => import(/* webpackChunkName: "resolve" */ '../views/h5OcrValidate/result.vue')
  },
  {
    path: '/validate/result2',  // 人脸核身换绑结果页
    name: 'validateResult2',
    component: () => import(/* webpackChunkName: "resolve" */ '../views/h5OcrValidate/result2.vue')
  },
  // 马达出行 风险标签+三要素+人脸核身
  {
    path: '/mada/treaty',
    name: 'madaTreaty',
    component: () => import(/* webpackChunkName: "resolve" */ '../views/madaApp/treaty.vue'),
    meta: {
      title: '认证解限'
    }
  },
  {
    path: '/mada/resolve',
    name: 'madaResolve',
    component: () => import(/* webpackChunkName: "resolve" */ '../views/madaApp/resolve.vue'),
    meta: {
      title: '认证解限'
    }
  },
  {
    path: '/mada/resolveTwo',
    name: 'madaResolveTwo',
    component: () => import(/* webpackChunkName: "resolve" */ '../views/madaApp/resolveTwo.vue'),
    meta: {
      title: '认证解限'
    }
  },
  {
    path: '/mada/result',
    name: 'madaResult',
    component: () => import(/* webpackChunkName: "resolve" */ '../views/madaApp/result.vue'),
    meta: {
      title: '认证解限'
    }
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  // 如果路由对象有自定义的title，则使用它
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
